import { render, staticRenderFns } from "./order-history-product-table.vue?vue&type=template&id=0b23837d&"
import script from "./order-history-product-table.vue?vue&type=script&lang=js&"
export * from "./order-history-product-table.vue?vue&type=script&lang=js&"
import style0 from "./order-history-product-table.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports